import { AutomationsPresentationV1 } from 'Automations/automationEditor'

export const isAutomationPresentation = (
  presentation: unknown
): presentation is AutomationsPresentationV1 => {
  return (
    typeof presentation === 'object' &&
    presentation !== null &&
    'nodes' in presentation &&
    Array.isArray(presentation.nodes) &&
    'edges' in presentation &&
    Array.isArray(presentation.edges)
  )
}
